import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Card, Typography, Avatar } from '@mui/material';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 120,
    '& .MuiAvatar-root': {
      background: theme.palette.colorPalette[2]
    },
    '& .MuiTypography-h2': {
      color: theme.palette.colorPalette[2]
    },
    '& .MuiTypography-overline': {
      color: '#888a91'
    }
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  headline: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.common.white,
    fontSize: '12px',
    fontWeight: 'bold'
  },
  amount: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '46px',
    lineHeight: '58px',
    fontWeight: 'bold',
    color: theme.palette.common.white
  },
  avatar: {
    background: theme.palette.common.white,
    height: 60,
    width: 60,
    '& .MuiSvgIcon-root': {
      fontSize: '32px'
    }
  },
  headlineWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}));

const OverviewBox = ({ headline = '', amount = 0, icon, className = 'light-blue', ...rest }) => {
  const classes = useStyles();

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <div>
        <Typography component="h3" gutterBottom variant="overline" className={classes.headline}>
          <div className={classes.headlineWrapper}>
            <div>{headline}</div>
          </div>
        </Typography>
        <div className={classes.details}>
          <Typography className={classes.amount} variant="h2">
            {amount}
          </Typography>
        </div>
      </div>
      <Avatar className={classes.avatar}>{icon}</Avatar>
    </Card>
  );
};

OverviewBox.propTypes = {
  className: PropTypes.string,
  headline: PropTypes.string,
  amount: PropTypes.number,
  icon: PropTypes.node
};

export default OverviewBox;
